import React from 'react';
import { useParams } from 'react-router-dom';
import { Box } from '@mui/material';
import { Toggle } from '../../quoteDetails/components/Toggle';
import { usePersona } from '../../../../../../components/hooks/usePersona';
import { QUOTE_FLOWS, type QuoteFlows } from '../../constants';
import type { AccountDto, ProductType } from '../../../../../../types';
import { useGetQuoteCartList } from '../../hooks/useGetQuoteCartList';
import { useQuoteCartStatus } from '../../../../../workflows/quotes/shared/quote-options/useQuoteCartStatus';
import { SUBMISSION_VIEWS } from '../../../../../submissions/modules/coverages/constants';

const RenewalToggle = ({
  accountData,
  productType,
  ...props
}: RenewalToggleProps) => {
  const persona = usePersona();
  const params = useParams<{
    quoteFlow: QuoteFlows;
    submissionId: string | undefined;
    view?: string;
  }>();

  const cartQuery = useGetQuoteCartList({
    accountData,
    accountId: accountData?.id ?? '',
    productType,
    // A submission holds coverage options, not a cart.
    enabled: !params.submissionId,
  });
  // The flag is part of every saved option's terms, so it locks once any is waiting to be quoted,
  // and while a submission's options are still loading and the count is unknown.
  const cartStatus = useQuoteCartStatus({
    submissionId: params.submissionId,
    productType,
    accountCartCount: cartQuery.data?.quoteList?.length ?? 0,
  });

  if (
    persona.isCowbell &&
    (params.quoteFlow === QUOTE_FLOWS.REQUEST_QUOTE ||
      params.view === SUBMISSION_VIEWS.quote) &&
    !!props.handleToggle
  ) {
    return (
      <Toggle
        handleToggle={props.handleToggle}
        toggleOn={props.toggleOn ?? false}
        label="Is Renewal?"
        disabled={
          cartQuery.isFetching || cartStatus.isPending || cartStatus.count > 0
        }
      />
    );
  }

  return <Box />;
};

export default RenewalToggle;

type RenewalToggleProps = {
  accountData: AccountDto | undefined;
  productType: ProductType;
  handleToggle?: () => void;
  toggleOn?: boolean;
};
